<template>
  <div class="rectification-container">
    <h3 class="title">关联整改单</h3>
    <div class="card-list" v-if="rectificationList.length">
      <!-- 循环渲染整改单卡片 -->
      <div v-for="(item, index) in rectificationList" :key="index" class="rectification-card">
        <div class="card-content">
          <div class="code-item">
            <span class="label">编号：</span>
            <span class="value">{{ item.hazardCode }}</span>
          </div>
          <div class="status-item">
            <span class="label">状态：</span>
            <el-tag :class="getStatusClass(item.rectifyStatus).class" size="small">
              {{ getStatusClass(item.rectifyStatus).name }}
            </el-tag>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <el-empty :image-size="100"></el-empty>
    </div>
  </div>
</template>

<script>
import { disposeDetail } from '@/basic-common/util/common.js';
import { getTraceHazardRectifyDetail } from "../api";
import 'echarts/theme/macarons' // 引入主题增强样式
export default {
  props: {
    detailForm: {}
  },
  data () {
    return {
      rectificationList: []
    };
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      getTraceHazardRectifyDetail(this.detailForm.id).then(({ data }) => {
        this.rectificationList = data.data
      })
    },
    // 根据状态返回不同的样式类名
    getStatusClass (status) {
      switch (status) {
        case 0:
          return { class: 'el-tag--info', name: '待整改' };
        case 1:
          return { class: 'el-tag--primary', name: '整改中' };
        case 2:
          return { class: 'el-tag--success', name: '已整改' };
        case 3:
          return { class: 'el-tag--danger', name: '已关闭' };
        case 4:
          return { class: 'el-tag--default', name: '已取消' };
        default:
          return { class: 'el-tag--default', name: '' };
      }
    }
  }
};
</script>
<style scoped>
.rectification-container {
  padding: 20px;
}

.title {
  margin: 0 0 15px 0;
  font-size: 16px;
  color: #333;
  font-weight: 500;
}

.card-list {
  display: flex;
  gap: 15px;
  flex-wrap: wrap; /* 自动换行 */
}

.rectification-card {
  flex: 1;
  min-width: 280px; /* 最小宽度，保证在小屏幕也能正常显示 */
  max-width: 350px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  padding: 15px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.rectification-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-color: #dcdfe6;
}

.card-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.code-item,
.status-item {
  display: flex;
  align-items: center;
}

.label {
  color: #606266;
  font-size: 14px;
  width: 60px;
}

.value {
  color: #303133;
  font-size: 14px;
  flex: 1;
  word-break: break-all; /* 防止长编号溢出 */
}
</style>